export {
  EvalRunT,
  EvalRunStatus,
  EvalRunStatusT,
  EvalRunResultT,
  EvalRunResultEventT,
  EvalRunResultScoreT,
  EvalRunResultEventScoreT,
  EvalRunConfigT,
  EvalRunConfigPersonaT,
  EvalRunConfigExpectedEventT,
  EvalRunConfigSimulationMode,
  EvalRunConfigSimulationModeT,
  EvalEvent,
  EvalEventT,
  EvalEventLabels,
  EvalEventLabelsT,
};

type EvalRunT = {
  workspace: string;
  assistant: string;
  company: string;
  createdBy: string;
  status: EvalRunStatusT;
  error: string;
  config: EvalRunConfigT;
  results: Array<EvalRunResultT>;
  createdAt: number;
  updatedAt: number;
  completedAt: number;
};

const EvalRunStatus = {
  PENDING: "pending",
  RUNNING: "running",
  COMPLETED: "completed",
  FAILED: "failed",
  STOPPED: "stopped",
} as const;

type EvalRunStatusT = (typeof EvalRunStatus)[keyof typeof EvalRunStatus];

const EvalRunConfigSimulationMode = {
  CHAT: "chat",
  VOICE: "voice",
} as const;

type EvalRunConfigSimulationModeT =
  (typeof EvalRunConfigSimulationMode)[keyof typeof EvalRunConfigSimulationMode];

type EvalRunConfigT = {
  modelsToTest: Array<string>;
  personas: Array<EvalRunConfigPersonaT>;
  qualityCriteria: Array<string>;
  maxTurns: number;
  endCriteria: string;
  simulationMode: EvalRunConfigSimulationModeT;
  simulatedTime: string;
  evaluatorModel: string;
  customerSimulatorModel: string;
  eventsToTrack: Array<string>;
  expectedEvents: Array<EvalRunConfigExpectedEventT>;
};

type EvalRunConfigPersonaT = {
  name: string;
  description: string;
  scenario: string;
  initialMessage: string;
  expectedOutput: string;
  interruptionRate: number;
  attributes?: Record<string, string>;
};

type EvalRunResultT = {
  model: string;
  persona: EvalRunConfigPersonaT["name"];
  conversation: any;
  endReason: string;
  eventsOccurred: Array<EvalRunResultEventT>;
  scores: Array<EvalRunResultScoreT>;
  eventScores: Array<EvalRunResultEventScoreT>;
  totalDurationMs: number;
  latencyMs: number;
};

type EvalRunResultScoreT = {
  criterion: string;
  score: number;
  reasoning: string;
};

type EvalRunResultEventScoreT = {
  event: string;
  expected: boolean;
  occurred: boolean;
  turn: number | null;
};

type EvalRunResultEventT = {
  event: string;
  turn: number;
  details: any;
  timestamp: number;
};

type EvalRunConfigExpectedEventT = {
  persona: EvalRunConfigPersonaT["name"];
  event: string;
  expected: boolean;
};

const EvalEvent = {
  HUMAN_AGENT_TRANSFER: "humanAgentTransfer",
  VOICEMAIL_DETECTED: "voicemailDetected",
  CALL_ON_HOLD_DETECTED: "callOnHoldDetected",
  SMS_TRIGGER: "smsTrigger",
  AUTO_CALL_END: "autoCallEnd",
  WHATSAPP_TRANSFER: "whatsappTransfer",
  EMAIL_TRIGGER: "emailTrigger",
  CUSTOM_API_CALL: "customAPICall",
  COACH_GUIDANCE: "coachGuidance",
} as const;

const EvalEventLabels = {
  [EvalEvent.HUMAN_AGENT_TRANSFER]: "Human Agent Transfer",
  [EvalEvent.VOICEMAIL_DETECTED]: "Voicemail Detected",
  [EvalEvent.CALL_ON_HOLD_DETECTED]: "Call on Hold Detected",
  [EvalEvent.SMS_TRIGGER]: "SMS Trigger",
  [EvalEvent.AUTO_CALL_END]: "Auto Call End",
  [EvalEvent.WHATSAPP_TRANSFER]: "Whatsapp Transfer",
  [EvalEvent.EMAIL_TRIGGER]: "Email Trigger",
  [EvalEvent.CUSTOM_API_CALL]: "Custom API Call",
  [EvalEvent.COACH_GUIDANCE]: "Coach Guidance",
};

type EvalEventLabelsT = Record<EvalEventT, string>;
type EvalEventT = (typeof EvalEvent)[keyof typeof EvalEvent];
